// src/locales/vi.ts
export default {
    common: {
        home: "Trang chủ",
        manage: "Quản lý",
        documents: "Tài liệu",
        documentLibrary: "Thư viện tài liệu",
        uploadDocument: "Tải lên tài liệu",
        myDocuments: "Tài liệu của tôi",
        myWall: "Tường của tôi",
        login: "Đăng nhập",
        register: "Đăng ký",
        logout: "Đăng xuất",
        settings: "Cài đặt & Quyền riêng tư",
        support: "Hỗ trợ",
        userGuide: "Tài liệu hướng dẫn",
        theme: "Giao diện",
        viewProfile: "Xem hồ sơ",
        light: "Sáng",
        dark: "Tối",
        auto: "Tự động",
        seeAll: "Xem tất cả",
        loading: "Đang tải...",
        save: "Lưu",
        cancel: "Hủy",
        continue: "Tiếp tục",
        back: "Quay lại",
        next: "Tiếp theo",
        close: "Đóng",
        clear: "Xóa tất cả",
        search: "Tìm kiếm...",
        notifications: "Thông báo",
        new: "mới",
        accept: "Chấp nhận",
        delete: "Xóa",
        yes: "Có",
        no: "Không",
        error: "Lỗi",
        success: "Thành công",
        warning: "Cảnh báo",
        info: "Thông tin",
        minutes: "phút",
        hours: "giờ",
        days: "ngày",
        ago: "trước",
        confirmAction: "Bạn có chắc chắn muốn thực hiện hành động này?",
        language: "Ngôn ngữ",
        helpTranslate: "Giúp dịch",
        view: "Xem",
        edit: "Sửa",
        submit: "Gửi",
        confirm: "Xác nhận",
        previous: "Trước",
        all: "Tất cả",
        none: "Không có",
        other: "Khác",
        more: "Xem thêm",
        less: "Thu gọn",
        comingSoon: "Sắp ra mắt",
        filter: "Lọc",
        sort: "Sắp xếp",
        quick: "Nhanh",
        actions: "Thao tác",
        sortBy: "Sắp xếp theo",
        download: "Tải xuống",
        pagination: "Hiển thị {{from}} đến {{to}} của {{total}} mục",
        noSubscription: "Không có gói đăng ký",
        total: "Tổng cộng",
        clearFilters: "Xóa bộ lọc",
        choose: "Chọn",
        file: "Tệp",
        or: "hoặc",
        dragDrop: "kéo và thả",
        up: "lên đến",
        to: "đến",
        select: "Chọn",
        enter: "Nhập",
        keyword: "Từ khóa",
        email: "Email",
        publicDescription: "Mô tả công khai",
        upload: "Tải lên",
        viewDetails: "Xem chi tiết",
        showing: "Hiển thị",
        of: "trong tổng số",
        results: "kết quả",
        filters: "Bộ lọc",
        status: "Trạng thái",
        export: "Xuất",
        plaintiff: "Nguyên đơn",
        defendant: "Bị đơn",
        items: "mục",
        sortOptions: {
            newest: "Mới nhất",
            oldest: "Cũ nhất",
            activity: "Hoạt động gần đây",
            downloads: "Lượt tải nhiều nhất",
            spent: "Chi tiêu nhiều nhất",
            amountHigh: "Số tiền (Cao đến Thấp)",
            amountLow: "Số tiền (Thấp đến Cao)",
            priceHigh: "Giá (Cao đến Thấp)",
            priceLow: "Giá (Thấp đến Cao)",
            revenue: "Doanh thu cao nhất",
            relevance: "Độ liên quan",
            priority: "Ưu tiên",
            reports: "Số lượng báo cáo"
        },
        locales: {
            vi: "Tiếng Việt",
            en: "Tiếng Anh"
        }
    },
    auth: {
        login: "Đăng nhập",
        register: "Đăng ký",
        logout: "Đăng xuất",
        forgotPassword: "Quên mật khẩu",
        resetPassword: "Đặt lại mật khẩu",
        username: "Tên đăng nhập",
        email: "Email",
        password: "Mật khẩu",
        confirmPassword: "Xác nhận mật khẩu",
        firstName: "Họ",
        lastName: "Tên",
        rememberMe: "Ghi nhớ đăng nhập",
        loginSubtitle: "Đăng nhập vào tài khoản của bạn",
        registerSubtitle: "Tạo tài khoản mới để quản lý bản quyền",
        registerSuccess: "Đăng ký thành công",
        registerSuccessMessage: "Cảm ơn bạn đã đăng ký tài khoản Vietrro. Chúng tôi đã gửi email xác nhận đến",
        passwordRequirements: "Mật khẩu phải có ít nhất 8 ký tự",
        alreadyHaveAccount: "Đã có tài khoản?",
        dontHaveAccount: "Chưa có tài khoản?",
        agreeTerms: "Tôi đồng ý với",
        termsOfService: "Điều khoản dịch vụ",
        and: "và",
        privacyPolicy: "Chính sách bảo mật",
        loginNow: "Đăng nhập ngay",
        registerNow: "Đăng ký ngay",
        registerAccount: "Đăng ký tài khoản",
        emailVerification: "Vui lòng kiểm tra hộp thư đến và nhấn vào liên kết xác nhận để hoàn tất quá trình đăng ký.",
        approvalRequired: "Tài khoản của bạn thuộc nhóm người dùng cần phê duyệt. Vui lòng chờ quản trị viên xét duyệt tài khoản của bạn. Chúng tôi sẽ thông báo cho bạn qua email khi tài khoản được phê duyệt.",
        openEmail: "Mở email",
        loginButton: "Đăng nhập",
        registerButton: "Đăng ký tài khoản",
        phoneNumber: "Số điện thoại",
        organization: "Tên tổ chức/doanh nghiệp",
        taxId: "Mã số thuế",
        businessInfo: "Thông tin doanh nghiệp",
        userInfo: "Thông tin người dùng",
        forgotPasswordButton: "Khôi phục mật khẩu",
        guest: "Khách"
    },
    register: {
        step1: "Chọn vai trò",
        step2: "Thông tin cá nhân",
        step3: "Xác nhận",
        selectRole: "Chọn vai trò của bạn trong hệ thống",
        selectMultipleRoles: "Chọn nhiều vai trò",
        selectedRoles: "Vai trò đã chọn:",
        noRoleSelected: "Chưa chọn vai trò nào",
        noRoleAvailable: "Không có nhóm người dùng nào có thể đăng ký.",
        validateUsername: "Tên đăng nhập phải có ít nhất 4 ký tự",
        usernameAvailable: "Tên đăng nhập hợp lệ",
        usernameNotAvailable: "Tên đăng nhập đã tồn tại hoặc không hợp lệ",
        confirmInformation: "Xác nhận thông tin",
        role: "Vai trò",
        fullName: "Họ và tên",
        phoneNumber: "Số điện thoại",
        organization: "Tổ chức",
        taxId: "Mã số thuế",
        specificRoles: "Các vai trò cụ thể",
        approvalNote: "Lưu ý: Tài khoản của bạn sẽ cần được phê duyệt trước khi có thể sử dụng đầy đủ tính năng.",
        registrationComplete: "Đăng ký hoàn tất"
    },
    header: {
        home: "Trang chủ",
        myWall: "Tường của tôi",
        manage: "Quản lý",
        identityProtection: "Bảo vệ hình ảnh cá nhân",
        marketplace: "Marketplace",
        documentMenu: "Tài liệu",
        documentLibrary: "Thư viện tài liệu",
        uploadDocument: "Tải lên tài liệu",
        myDocuments: "Tài liệu của tôi",
        settings: "Cài đặt",
        viewProfile: "Xem hồ sơ",
        logout: "Đăng xuất",
        userGuide: "Tài liệu hướng dẫn",
        theme: "Giao diện",
        messaging: "Tin nhắn",
        openMenu: "Mở menu",
        closeMenu: "Đóng menu",
        education: 'Giáo dục',
        educationDashboard: 'Bảng điều khiển Giáo dục',
        educationDocuments: 'Tài liệu Giáo dục',
        educationSettings: 'Cài đặt Giáo dục',
        notifications: {
            title: "Thông báo",
            empty: "Không có thông báo mới",
            seeAll: "Xem tất cả hoạt động"
        }
    },
    search: {
        placeholder: "Tìm kiếm...",
        ariaLabel: "Tìm kiếm",
        submit: "Tìm kiếm",
        advancedSearch: "Tìm kiếm nâng cao",
        filters: "Bộ lọc",
        results: "Kết quả tìm kiếm"
    },
    user: {
        profile: "Hồ sơ",
        settings: "Cài đặt",
        accountSettings: "Cài đặt tài khoản",
        privacySettings: "Cài đặt quyền riêng tư",
        notificationSettings: "Cài đặt thông báo",
        securitySettings: "Cài đặt bảo mật",
        verifiedBadge: "Huy hiệu xác thực",
        membership: "Tư cách thành viên",
        memberSince: "Thành viên từ",
        mutualConnections: "Kết nối chung"
    },
    content: {
        registerWork: "Đăng ký tác phẩm mới",
        manageCatalog: "Quản lý danh mục",
        updateMetadata: "Cập nhật metadata",
        revenueDashboard: "Thống kê doanh thu",
        withdrawPayment: "Rút tiền từ bản quyền",
        reportViolation: "Báo cáo vi phạm",
        identityProtection: "Trung tâm bảo vệ danh tính"
    },
    license: {
        exploreWorks: "Khám phá tác phẩm có bản quyền",
        purchaseLicense: "Mua giấy phép sử dụng",
        licensePayments: "Thanh toán phí bản quyền",
        viewContracts: "Xem hợp đồng hiện tại",
        manageContracts: "Gia hạn/Hủy hợp đồng",
        viewExpiredContracts: "Xem hợp đồng đã hết hạn"
    },
    navigation: {
        home: "Trang chủ",
        dashboard: "Bảng điều khiển",
        profile: "Hồ sơ",
        userProfile: "Hồ sơ người dùng",
        settings: "Cài đặt",
        vietrroHome: "Vietrro Home",
        general: "Tổng quan",
        copyrightManagement: "Quản lý bản quyền",
        licensing: "Cấp phép bản quyền",
        education: "Giáo dục",
        documents: "Tài liệu",
        monitoring: "Giám sát",
        legal: "Pháp lý",
        administration: "Quản trị",
        account: "Tài khoản",
        protection: "Bảo vệ bản quyền",
        userWall: "Tường cá nhân",
        logout: "Đăng xuất"
    },
    education: {
        "sidebar": {
            "menu": "Menu",
            "expand": "Mở rộng",
            "collapse": "Thu gọn",
            "close": "Đóng menu",
            "logout": "Đăng xuất",
            "user": {
                "guest": "Khách",
                "noRole": "Người dùng",
                "teacher": "Giáo viên",
                "student": "Học sinh",
                "admin": "Quản trị viên",
                "user": "Người dùng",
                "online": "Trực tuyến"
            },
            "dashboard": {
                "title": "Trang chủ",
                "overview": "Tổng quan",
                "teacher": "Dashboard Giáo viên",
                "student": "Dashboard Học sinh"
            },
            "documents": {
                "title": "Tài liệu",
                "all": "Tất cả tài liệu",
                "upload": "Tải lên tài liệu",
                "myDocuments": "Tài liệu của tôi",
                "myPurchases": "Đã mua",
                "myDownloads": "Đã tải xuống"
            },
            "subscription": {
                "title": "Đăng ký",
                "plans": "Gói đăng ký",
                "mySubscription": "Đăng ký của tôi"
            },
            "revenue": {
                "title": "Doanh thu",
                "earnings": "Thu nhập",
                "analytics": "Phân tích doanh thu",
                "withdraw": "Rút tiền"
            },
            "payments": {
                "title": "Thanh toán",
                "history": "Lịch sử thanh toán",
                "methods": "Phương thức thanh toán"
            },
            "analytics": {
                "title": "Phân tích",
                "overview": "Tổng quan phân tích",
                "documents": "Phân tích tài liệu",
                "revenue": "Phân tích doanh thu",
                "users": "Phân tích người dùng"
            },
            "profile": {
                "title": "Hồ sơ",
                "teacher": "Hồ sơ giáo viên",
                "student": "Hồ sơ học sinh",
                "verification": "Xác thực tài khoản"
            },
            "admin": {
                "title": "Quản trị",
                "teachers": "Quản lý giáo viên",
                "students": "Quản lý học sinh",
                "verification": "Xác thực tài khoản",
                "moderation": "Kiểm duyệt nội dung"
            },
            "settings": {
                "title": "Cài đặt",
                "general": "Cài đặt chung",
                "notifications": "Thông báo",
                "privacy": "Riêng tư"
            },
            "help": {
                "title": "Trợ giúp",
                "faq": "Câu hỏi thường gặp",
                "contact": "Liên hệ hỗ trợ"
            },
            "notifications": {
                "title": "Thông báo"
            }
        },
        dashboard: {
            title: "Bảng điều khiển",
            welcome: "Chào mừng đến với Vietrro Education",
            welcomeTeacher: "Xin chào, {{name}}! Tài liệu giáo dục của bạn đang tạo ra sự khác biệt.",
            welcomeStudent: "Chào mừng trở lại, {{name}}! Bạn đã sẵn sàng học điều mới hôm nay chưa?",
            teacher: "Bảng điều khiển giáo viên",
            student: "Bảng điều khiển học sinh",
            stats: "Thống kê",
            recentDocuments: "Tài liệu gần đây",
            recentActivities: "Hoạt động gần đây",
            welcomeMessage: "Chào mừng {{name}}",
            totalDocuments: "Tổng số tài liệu",
            myDocuments: "Tài liệu của tôi",
            recentUploads: "Tài liệu đã tải lên gần đây",
            earnings: "Doanh thu",
            downloads: "Lượt tải xuống",
            reviews: "Đánh giá",
            averageRating: "Đánh giá trung bình",
            activeSubscription: "Gói đăng ký hiện tại",
            overview: "Tổng quan bảng điều khiển",
            statistics: {
                thisMonth: "Tháng này",
                lastMonth: "Tháng trước"
            }
        },
        documents: {
            title: "Tài liệu học tập",
            searchPlaceholder: "Tìm kiếm tài liệu...",
            uploadDocument: "Tải lên tài liệu",
            documentDetails: "Chi tiết tài liệu",
            myDocuments: "Tài liệu của tôi",
            editDocument: "Chỉnh sửa tài liệu",
            reviews: "Đánh giá",
            filterBySubject: "Lọc theo môn học",
            filterByLevel: "Lọc theo cấp học",
            documentTypes: {
                learning_material: "Tài liệu học tập",
                reference_material: "Tài liệu tham khảo",
                research_paper: "Bài nghiên cứu",
                study_guide: "Hướng dẫn học tập"
            },
            educationLevels: {
                primary: "Tiểu học",
                secondary: "THCS",
                high_school: "THPT",
                university: "Đại học",
                masters: "Thạc sĩ",
                phd: "Tiến sĩ"
            },
            status: {
                approved: "Đã duyệt",
                pending: "Đang chờ duyệt",
                rejected: "Đã từ chối",
                draft: "Bản nháp",
                deleted: "Đã xóa"
            },
            // title: "Tiêu đề",
            noDocuments: "Không tìm thấy tài liệu nào",
            recentDownloads: "Tài liệu đã tải xuống gần đây",
            savedDocuments: "Tài liệu đã lưu",
            browseLibrary: "Duyệt thư viện",
            documentCount: "Số lượng tài liệu",
            noResults: "Không tìm thấy kết quả",
            tryAnotherSearch: "Thử từ khóa tìm kiếm khác",
            subjects: {
                math: "Toán học",
                literature: "Văn học",
                english: "Tiếng Anh",
                physics: "Vật lý",
                chemistry: "Hóa học",
                biology: "Sinh học",
                history: "Lịch sử",
                geography: "Địa lý",
                informatics: "Tin học",
                economics: "Kinh tế học",
                art: "Mỹ thuật",
                music: "Âm nhạc",
                physical_education: "Giáo dục thể chất"
            }
        },
        subscription: {
            title: "Gói đăng ký",
            plans: "Danh sách gói",
            mySubscription: "Gói đăng ký của tôi",
            upgrade: "Nâng cấp gói",
            downgrade: "Hạ cấp gói",
            cancel: "Hủy gói",
            renew: "Gia hạn gói",
            status: {
                active: "Đang hoạt động",
                pending: "Đang chờ",
                expired: "Đã hết hạn",
                cancelled: "Đã hủy",
                suspended: "Tạm dừng",
                none: "Không có",
                inactive: "Không hoạt động"
            },
            actions: {
                manageBilling: "Quản lý thanh toán",
                subscribe: "Đăng ký"
            },
            newSubscriber: "Người đăng ký mới",
            my: "Gói đăng ký của tôi",
            noActiveSubscription: "Không có gói đăng ký đang hoạt động",
            subscribeToPlan: "Đăng ký gói",
            activeSubscription: "Gói đăng ký đang hoạt động",
            inactiveMessage: "Bạn không có gói đăng ký đang hoạt động",
            purchaseCount: "Số lần mua",
            subtitle: "Truy cập nội dung giáo dục cao cấp",
            whySubscribe: "Tại sao nên đăng ký?",
            benefitTitles: {
                unlimitedDownloads: "Tải xuống không giới hạn",
                premiumContent: "Nội dung cao cấp",
                collaboration: "Hợp tác với giáo viên",
                analytics: "Phân tích sử dụng"
            },
            benefitDescs: {
                unlimitedDownloads: "Tải xuống nhiều tài liệu như bạn cần",
                premiumContent: "Truy cập các tài liệu chất lượng cao độc quyền",
                collaboration: "Kết nối với giáo viên chuyên nghiệp",
                analytics: "Theo dõi tiến trình học tập của bạn"
            },
            choosePlan: "Chọn gói đăng ký",
            allPlans: "Tất cả gói",
            studentPlans: "Gói dành cho học sinh",
            teacherPlans: "Gói dành cho giáo viên",
            autoRenew: "Tự động gia hạn gói đăng ký",
            active: "Đang hoạt động",
            expired: "Đã hết hạn",
            none: "Không có"
        },
        payments: {
            title: "Thanh toán",
            history: "Lịch sử thanh toán",
            methods: {
                title: "Phương thức thanh toán",
                add: "Thêm phương thức",
                edit: "Sửa phương thức",
                delete: "Xóa phương thức"
            },
            revenue: {
                title: "Quản lý doanh thu",
                withdraw: "Rút tiền",
                history: "Lịch sử rút tiền"
            }
        },
        analytics: {
            title: "Phân tích",
            overview: "Xem thống kê và báo cáo chi tiết",
            documents: "Phân tích tài liệu",
            revenue: "Phân tích doanh thu",
            users: "Phân tích người dùng",
            noData: "Không có dữ liệu phân tích"
        },
        users: {
            teachers: {
                title: "Giáo viên",
                profile: "Hồ sơ giáo viên",
                verification: "Xác minh giáo viên"
            },
            students: {
                title: "Học sinh",
                profile: "Hồ sơ học sinh"
            }
        },
        admin: {
            title: "Quản trị giáo dục",
            accountApproval: "Duyệt tài khoản",
            moderation: "Kiểm duyệt tài liệu",
            students: "Học sinh",
            verification: "Xác minh",
            // moderation: "Kiểm duyệt"
        },
        student: {
            purchases: "Tài liệu đã mua",
            downloads: "Tài liệu đã tải",
            myDownloads: "Tài liệu đã tải xuống",
            myDownloadsDescription: "Quản lý tất cả tài liệu bạn đã tải xuống từ hệ thống",
            downloadedOn: "Đã tải xuống vào: {{date}}",
            remainingDownloads: "Còn lại {{count}} lượt tải xuống",
            noDownloads: "Chưa có tài liệu nào được tải xuống",
            noDownloadsDescription: "Bạn chưa tải xuống tài liệu nào. Hãy tìm kiếm và tải xuống tài liệu từ thư viện của chúng tôi.",
            browseDocuments: "Duyệt thư viện tài liệu"
        },
        settings: {
            title: "Cài đặt",
            general: {
                title: "Cài đặt chung"
            },
            notifications: {
                title: "Cài đặt thông báo"
            },
            privacy: {
                title: "Cài đặt quyền riêng tư"
            },
            tabs: {
                profile: "Hồ sơ",
                notifications: "Thông báo",
                privacy: "Quyền riêng tư",
                preferences: "Tùy chọn",
                security: "Bảo mật",
                payments: "Thanh toán",
                data: "Dữ liệu"
            },
            loading: "Đang tải cài đặt...",
            description: "Quản lý cài đặt tài khoản và tùy chọn của bạn",
            profile: {
                info: "Thông tin hồ sơ",
                displayName: "Tên hiển thị",
                bio: "Tiểu sử",
                bioPlaceholder: "Hãy giới thiệu về bản thân...",
                website: "Trang web",
                socialLinks: "Liên kết mạng xã hội"
            }
        },
        help: {
            title: "Trợ giúp",
            faq: "Câu hỏi thường gặp",
            categories: {
                gettingStarted: "Bắt đầu sử dụng",
                subscription: "Gói đăng ký",
                documents: "Tài liệu",
                payments: "Thanh toán",
                upload: "Tải lên",
                verification: "Xác minh",
                general: "Chung"
            },
            categoryDescriptions: {
                upload: "Tìm hiểu cách tải lên tài liệu",
                subscription: "Thông tin về các gói đăng ký",
                payment: "Trợ giúp về phương thức thanh toán và hóa đơn",
                verification: "Hiểu về quy trình xác minh",
                general: "Câu hỏi chung về nền tảng"
            },
            contact: {
                title: "Liên hệ hỗ trợ",
                form: "Biểu mẫu liên hệ",
                email: "Email hỗ trợ",
                phone: "Số điện thoại hỗ trợ"
            },
            loading: "Đang tải Trung tâm trợ giúp...",
            description: "Tìm câu trả lời cho các câu hỏi của bạn",
            searchPlaceholder: "Tìm kiếm chủ đề trợ giúp...",
            quickHelp: "Trợ giúp nhanh",
            questions: "Câu hỏi",
            frequentlyAskedQuestions: "Câu hỏi thường gặp",
            noQuestions: "Không tìm thấy câu hỏi nào",
            selectCategory: "Chọn danh mục",
            askQuestion: "Đặt câu hỏi",
            contactSupport: "Liên hệ hỗ trợ",
            liveChat: "Trò chuyện trực tiếp",
            liveChatDescription: "Trò chuyện với đội ngũ hỗ trợ của chúng tôi",
            startChat: "Bắt đầu trò chuyện",
            emailDescription: "Gửi email cho đội ngũ hỗ trợ của chúng tôi",
            replyWithin24h: "Chúng tôi sẽ trả lời trong vòng 24 giờ",
            hotlineDescription: "Gọi đường dây nóng hỗ trợ của chúng tôi",
            resources: "Tài nguyên",
            videoTutorials: "Video hướng dẫn",
            videoTutorialsDescription: "Học với video hướng dẫn từng bước",
            userManual: "Sách hướng dẫn sử dụng",
            userManualDescription: "Tài liệu đầy đủ về nền tảng",
            freeCourses: "Khóa học miễn phí",
            freeCoursesDescription: "Học cách sử dụng nền tảng hiệu quả"
        },
        notifications: {
            title: "Thông báo",
            markAsRead: "Đánh dấu đã đọc",
            markAllAsRead: "Đánh dấu tất cả đã đọc",
            clear: "Xóa tất cả",
            empty: "Không có thông báo",
            unread: "Chưa đọc",
            settings: {
                title: "Cài đặt thông báo"
            },
            priority: {
                high: "Ưu tiên cao"
            },
            types: {
                document: "Tài liệu",
                payment: "Thanh toán"
            },
            search: "Tìm kiếm thông báo...",
            viewDetails: "Xem chi tiết",
            channels: {
                app: "Trong ứng dụng",
                email: "Email"
            }
        },
        navigation: {
            dashboard: "Bảng điều khiển",
            overview: "Tổng quan",
            teacherDashboard: "Bảng điều khiển Giáo viên",
            studentDashboard: "Bảng điều khiển Học sinh",
            documents: "Tài liệu",
            allDocuments: "Tất cả tài liệu",
            uploadDocument: "Tải lên tài liệu",
            myDocuments: "Tài liệu của tôi",
            myPurchases: "Đã mua",
            myDownloads: "Đã tải xuống",
            subscription: "Gói đăng ký",
            subscriptionPlans: "Các gói đăng ký",
            mySubscription: "Gói của tôi",
            revenue: "Doanh thu",
            earnings: "Thu nhập",
            analytics: "Phân tích",
            withdraw: "Rút tiền",
            payments: "Thanh toán",
            paymentHistory: "Lịch sử thanh toán",
            paymentMethods: "Phương thức thanh toán",
            management: "Quản lý",
            students: "Học sinh",
            verification: "Xác minh",
            moderation: "Kiểm duyệt",
            settings: "Cài đặt",
            general: "Chung",
            notifications: "Thông báo",
            privacy: "Quyền riêng tư",
            help: "Trợ giúp",
            faq: "Câu hỏi thường gặp",
            contact: "Liên hệ",
            closeMobileMenu: "Đóng menu",
            documentAnalytics: "Phân tích tài liệu",
            revenueAnalytics: "Phân tích doanh thu",
            userAnalytics: "Phân tích người dùng",
            profile: "Hồ sơ",
            teacherProfile: "Hồ sơ giáo viên",
            studentProfile: "Hồ sơ học sinh",
            admin: "Quản trị",
            teachers: "Quản lý giáo viên",
            mainMenu: "Menu chính"
        },
        forms: {
            uploadForm: {
                title: "Thông tin tài liệu",
                documentTitle: "Tiêu đề tài liệu",
                description: "Mô tả",
                selectFile: "Chọn file",
                documentType: "Loại tài liệu",
                subject: "Môn học",
                educationLevel: "Cấp học",
                price: "Giá (VND)",
                coAuthors: "Đồng tác giả",
                freeDocument: "Tài liệu miễn phí",
                keywords: "Từ khóa",
                sharePercentage: "Tỷ lệ chia sẻ",
                addCoAuthor: "Thêm đồng tác giả",
                publicDocument: "Tài liệu công khai",
                preview: "Xem trước"
            }
        },
        validation: {
            required: "Trường này là bắt buộc",
            minLength: "Tối thiểu {{count}} ký tự",
            maxLength: "Tối đa {{count}} ký tự",
            invalidEmail: "Email không hợp lệ",
            minPrice: "Giá phải lớn hơn {{min}}"
        },
        teacherManagement: "Quản lý giáo viên",
        manageTeachers: "Quản lý tài khoản, xác minh và quyền của giáo viên",
        teacher: "Giáo viên",
        teacherInfo: "Thông tin giáo viên",
        allStatus: "Tất cả trạng thái",
        allVerification: "Tất cả trạng thái xác minh",
        allInstitutions: "Tất cả trường/viện",
        status: {
            active: "Đang hoạt động",
            suspended: "Bị đình chỉ",
            pending: "Đang chờ",
            inactive: "Không hoạt động"
        },
        verification: {
            title: "Xác minh giáo viên",
            description: "Hoàn thành thông tin hồ sơ để xác minh tư cách giáo viên của bạn",
            notFound: "Không tìm thấy xác minh",
            notFoundDesc: "Xác minh bạn đang tìm kiếm không tồn tại hoặc đã bị xóa",
            reviewMode: "Xem xét chi tiết xác minh giáo viên",
            status: {
                draft: "Bản nháp",
                submitted: "Đã nộp",
                pending: "Đang chờ xem xét",
                underReview: "Đang xem xét",
                approved: "Đã phê duyệt",
                rejected: "Đã từ chối",
                expired: "Đã hết hạn"
            },
            personalInfo: "Thông tin cá nhân",
            professionalInfo: "Thông tin nghề nghiệp",
            documents: "Tài liệu xác minh",
            documentTypes: {
                id_card: "CCCD / Hộ chiếu",
                passport: "Hộ chiếu",
                degree: "Bằng cấp / Chứng chỉ",
                teaching_license: "Chứng chỉ giảng dạy",
                employment_letter: "Xác nhận công tác",
                other: "Tài liệu khác"
            },
            documentStatus: {
                pending: "Đang chờ",
                verified: "Đã xác minh",
                rejected: "Đã từ chối"
            },
            addDocument: "Thêm tài liệu",
            documentType: "Loại tài liệu",
            selectFiles: "Chọn tập tin",
            noDocuments: "Chưa có tài liệu nào được tải lên",
            uploadFirst: "Tải lên tài liệu đầu tiên của bạn",
            requiredDocuments: "Tài liệu bắt buộc",
            submit: "Nộp hồ sơ xác minh",
            approve: "Phê duyệt",
            reject: "Từ chối",
            confirmSubmit: "Nộp hồ sơ xác minh",
            confirmSubmitMessage: "Bạn có chắc chắn muốn nộp hồ sơ xác minh không? Bạn sẽ không thể chỉnh sửa cho đến khi quá trình xem xét hoàn tất.",
            confirmApproval: "Phê duyệt xác minh",
            confirmApprovalMessage: "Bạn có chắc chắn muốn phê duyệt xác minh giáo viên này không?",
            reviewNotePlaceholder: "Thêm ghi chú về việc phê duyệt này (tùy chọn)",
            confirmRejection: "Từ chối xác minh",
            confirmRejectionMessage: "Vui lòng cung cấp lý do từ chối. Điều này sẽ được hiển thị cho giáo viên.",
            rejectionReasonPlaceholder: "Lý do từ chối (bắt buộc)",
            rejected: "Xác minh bị từ chối",
            expired: "Xác minh đã hết hạn",
            uploadFiles: "Tải tập tin lên",
            uploadDocument: "Tải tài liệu lên",
            dateOfBirth: "Ngày sinh",
            nationality: "Quốc tịch",
            institutionName: "Tên trường/viện",
            institutionType: "Loại trường/viện",
            institutionAddress: "Địa chỉ trường/viện",
            department: "Khoa/Bộ môn",
            position: "Chức vụ",
            teacherIdNumber: "Mã số giáo viên",
            yearsOfExperience: "Số năm kinh nghiệm",
            specializations: "Chuyên môn",
            addSpecialization: "Thêm chuyên môn (nhấn Enter)",
            employmentStartDate: "Ngày bắt đầu công tác",
            reviewHistory: "Lịch sử xem xét",
            actions: {
                submitted: "Đã nộp",
                approved: "Đã phê duyệt",
                rejected: "Đã từ chối",
                requested_changes: "Yêu cầu thay đổi"
            },
            verified: "Đã xác minh",
            pending: "Đang chờ",
            // rejected: "Bị từ chối"
        },
        suspend: "Đình chỉ",
        activate: "Kích hoạt",
        activeTeachers: "Giáo viên đang hoạt động",
        pendingVerification: "Chờ xác minh",
        suspendedTeachers: "Giáo viên bị đình chỉ",
        newThisMonth: "Mới trong tháng này",
        institution: "Trường/Viện",
        department: "Khoa/Bộ môn",
        statistics: "Thống kê",
        lastLogin: "Đăng nhập cuối",
        teacherIdNumber: "Mã giáo viên",
        confirmSuspend: "Đình chỉ giáo viên",
        suspendWarning: "Điều này sẽ ngăn giáo viên tải lên tài liệu mới và kiếm doanh thu. Bạn có chắc không?",
        suspendReason: "Lý do đình chỉ (bắt buộc)",
        confirmDelete: "Xóa giáo viên",
        deleteTeacherWarning: "Hành động này không thể hoàn tác. Tất cả dữ liệu giáo viên bao gồm tài liệu và doanh thu sẽ bị xóa vĩnh viễn.",
        noTeachers: "Không tìm thấy giáo viên nào phù hợp với tiêu chí của bạn",
        searchTeachers: "Tìm giáo viên theo tên, email, trường/viện...",
        addTeacher: "Thêm giáo viên",
        editTeacher: "Chỉnh sửa giáo viên",
        permissions: {
            DOCUMENT_UPLOAD: "Tải lên tài liệu",
            STUDENT_MANAGEMENT: "Quản lý học sinh",
            ANALYTICS: "Xem phân tích",
            EXPORT_DATA: "Xuất dữ liệu"
        },
        institutionTypes: {
            university: "Đại học",
            college: "Cao đẳng",
            high_school: "THPT",
            private_institution: "Tổ chức tư nhân",
            other: "Khác"
        },
        joinedAt: "Tham gia vào",
        recentActivity: "Hoạt động gần đây",
        institutionName: "Tên trường/viện",
        earnings: {
            title: "Doanh thu",
            trackRevenue: "Theo dõi doanh thu và rút tiền",
            totalEarnings: "Tổng doanh thu",
            pendingPayments: "Thanh toán đang chờ",
            availableWithdraw: "Khả dụng để rút",
            platformFee: "Phí nền tảng",
            withdraw: "Rút tiền",
            fromLastMonth: "so với tháng trước",
            willBeAvailable: "Sẽ khả dụng trong 30 ngày",
            yourShare: "Phần của bạn",
            revenueChart: "Biểu đồ doanh thu",
            revenueSources: "Nguồn doanh thu",
            revenueSharing: "Chia sẻ doanh thu",
            afterPlatformFee: "sau phí nền tảng",
            coAuthorsShare: "Phần của đồng tác giả",
            distributedAmongCoAuthors: "Phân phối giữa các đồng tác giả nội dung",
            platformFeeAmount: "Phí nền tảng",
            serviceFee: "phí dịch vụ",
            topEarningDocuments: "Tài liệu có doanh thu cao nhất",
            sales: "Bán hàng",
            earnings: "Doanh thu",
            trend: "Xu hướng",
            withdrawalHistory: "Lịch sử rút tiền",
            date: "Ngày",
            amount: "Số tiền",
            bankInfo: "Thông tin ngân hàng",
            status: "Trạng thái",
            transactionId: "Mã giao dịch",
            requestWithdrawal: "Yêu cầu rút tiền",
            withdrawAmount: "Số tiền rút",
            available: "Khả dụng",
            selectBank: "Chọn ngân hàng",
            accountNumber: "Số tài khoản",
            accountHolder: "Tên chủ tài khoản",
            enterAccountNumber: "Nhập số tài khoản của bạn",
            enterAccountHolder: "Nhập tên chủ tài khoản",
            withdrawalNote: "Lưu ý quan trọng",
            withdrawalTime: "Yêu cầu rút tiền được xử lý trong vòng 3-5 ngày làm việc",
            minimumWithdrawal: "Số tiền rút tối thiểu là 50.000 VND",
            transactionFee: "Phí giao dịch 1% sẽ được áp dụng cho số tiền rút",
            confirmWithdraw: "Xác nhận rút tiền",
            withdrawalStatus: {
                pending: "Đang chờ",
                processing: "Đang xử lý",
                completed: "Hoàn thành",
                failed: "Thất bại"
            },
            sources: {
                sales: "Bán hàng trực tiếp",
                subscription: "Doanh thu từ gói đăng ký",
                referral: "Thưởng giới thiệu",
                bonus: "Thưởng khuyến khích"
            },
            exportReport: "Xuất báo cáo",
            noData: "Không có dữ liệu doanh thu"
        },
        educationLevels: {
            primary: "Tiểu học",
            secondary: "THCS",
            high_school: "THPT",
            university: "Đại học",
            masters: "Thạc sĩ",
            phd: "Tiến sĩ"
        },
        totalDocuments: "Tổng số tài liệu",
        totalRevenue: "Tổng doanh thu",
        totalDownloads: "Tổng lượt tải",
        totalStudents: "Tổng số học sinh",
        document: {
            title: "Tiêu đề",
            downloads: "Lượt tải",
            rating: "Đánh giá"
        },
        dateRange: {
            last7Days: "7 ngày qua",
            last30Days: "30 ngày qua",
            last3Months: "3 tháng qua",
            lastYear: "Năm qua",
            all: "Tất cả thời gian"
        },
        sorts: {
            recent: "Gần đây nhất",
            title: "Theo tiêu đề",
            type: "Theo loại tài liệu"
        },
        filters: {
            educationLevel: "Cấp học",
            documentType: "Loại tài liệu",
            subject: "Môn học",
            all: "Tất cả"
        },
        errors: {
            fetchFailed: "Không thể tải dữ liệu. Vui lòng thử lại sau.",
            downloadFailed: "Không thể tải xuống tài liệu. Vui lòng thử lại sau.",
            downloadHistoryError: "Đã xảy ra lỗi khi tải lịch sử tải xuống",
            networkAfterRetry: "Không thể kết nối đến máy chủ sau nhiều lần thử lại.",
            unauthorized: "Bạn không có quyền thực hiện hành động này.",
            notFound: "Không tìm thấy dữ liệu yêu cầu.",
            badRequest: "Yêu cầu không hợp lệ.",
            fileTooLarge: "File tải lên quá lớn.",
            serverError: "Lỗi máy chủ.",
            network: "Lỗi kết nối mạng.",
            generic: "Đã xảy ra lỗi.",
            approvalError: "Lỗi khi tải dữ liệu phê duyệt",
            approveFailed: "Không thể phê duyệt yêu cầu",
            rejectFailed: "Không thể từ chối yêu cầu"
        },
        documentManagement: "Quản lý tài liệu",
        newDocument: "Tài liệu mới",
        selectAll: "Chọn tất cả",
        noDocuments: "Không tìm thấy tài liệu nào",
        createFirstDocument: "Tạo tài liệu đầu tiên của bạn",
        confirmDeleteMessage: "Bạn có chắc chắn muốn xóa tài liệu này không?",
        thisMonth: "Tháng này",
        searchDocuments: "Tìm kiếm tài liệu",
        recommendations: {
            title: "Đề xuất cho bạn",
            noRecommendations: "Không có đề xuất nào"
        },
        purchase: {
            myPurchases: "Tài liệu đã mua",
            manageDownloads: "Quản lý tải xuống",
            totalPurchases: "Tổng số lần mua",
            totalSpent: "Tổng chi tiêu",
            completedPurchases: "Giao dịch hoàn thành",
            totalDownloads: "Tổng lượt tải xuống",
            searchPurchases: "Tìm kiếm mua hàng...",
            allStatus: "Tất cả trạng thái",
            status: {
                completed: "Hoàn thành",
                pending: "Đang chờ",
                failed: "Thất bại",
                refunded: "Đã hoàn tiền"
            },
            noPurchases: "Không tìm thấy giao dịch mua nào",
            startBrowsing: "Bắt đầu duyệt"
        },
        payment: {
            history: "Lịch sử thanh toán",
            trackAllTransactions: "Theo dõi tất cả giao dịch",
            listView: "Xem dạng danh sách",
            chartView: "Xem dạng biểu đồ",
            totalPayments: "Tổng số giao dịch",
            totalAmount: "Tổng số tiền",
            pendingPayments: "Giao dịch đang chờ",
            failedPayments: "Giao dịch thất bại",
            searchPayments: "Tìm kiếm giao dịch...",
            allTypes: "Tất cả loại",
            types: {
                purchase: "Mua hàng",
                subscription: "Đăng ký",
                withdrawal: "Rút tiền"
            },
            allStatus: "Tất cả trạng thái",
            status: {
                completed: "Hoàn thành",
                pending: "Đang chờ",
                failed: "Thất bại",
                refunded: "Đã hoàn tiền"
            },
            allMethods: "Tất cả phương thức",
            methods: {
                credit_card: "Thẻ tín dụng",
                bank_transfer: "Chuyển khoản ngân hàng",
                e_wallet: "Ví điện tử",
                paypal: "PayPal"
            },
            transaction: "Giao dịch",
            type: "Loại",
            amount: "Số tiền",
            paymentMethod: "Phương thức thanh toán",
            // status: "Trạng thái"
        },
        studentManagement: "Quản lý học sinh",
        manageStudents: "Quản lý học sinh",
        addStudent: "Thêm học sinh",
        searchStudents: "Tìm kiếm học sinh...",
        allSubscriptions: "Tất cả gói đăng ký",
        allYears: "Tất cả năm học",
        year: "Năm học",
        activeStudents: "Học sinh đang hoạt động",
        activeSubscriptions: "Gói đăng ký đang hoạt động",
        suspendedStudents: "Học sinh bị đình chỉ",
        studentId: "Mã học sinh / sinh viên",
        activity: "Hoạt động",
        approval: {
            accountApprovals: "Phê duyệt tài khoản",
            reviewAndManageApplications: "Xem xét và quản lý các yêu cầu đăng ký tài khoản",
            searchApplications: "Tìm kiếm yêu cầu...",
            allApplications: "Tất cả yêu cầu",
            applicationDetails: "Chi tiết yêu cầu",
            applicantInfo: "Thông tin người đăng ký",
            verificationInfo: "Thông tin xác minh",
            submittedDocuments: "Tài liệu đã nộp",
            reviewNotes: "Ghi chú đánh giá",
            enterReviewNotes: "Nhập ghi chú đánh giá (tùy chọn)",
            previousReview: "Đánh giá trước đó",
            reviewedBy: "Được đánh giá bởi",
            reviewedAt: "Thời gian đánh giá",
            notes: "Ghi chú",
            submittedAt: "Đã nộp lúc",
            review: "Xem xét",
            approve: "Phê duyệt",
            reject: "Từ chối",
            confirmApproval: "Xác nhận phê duyệt",
            confirmApprovalMessage: "Bạn có chắc chắn muốn phê duyệt yêu cầu này không?",
            confirmRejection: "Xác nhận từ chối",
            confirmRejectionMessage: "Vui lòng cung cấp lý do từ chối:",
            enterRejectionReason: "Nhập lý do từ chối (bắt buộc)",
            rejectionReasonRequired: "Vui lòng nhập lý do từ chối",
            viewDocument: "Xem tài liệu",
            pendingApplications: "Yêu cầu chờ duyệt",
            underReview: "Đang xem xét",
            approvedToday: "Đã duyệt hôm nay",
            rejectedToday: "Đã từ chối hôm nay",
            noApplications: "Không có yêu cầu nào",
            noApplicationsDescription: "Hiện tại không có yêu cầu phê duyệt nào cần xử lý",
            status: {
                pending: "Chờ duyệt",
                reviewing: "Đang xem xét",
                approved: "Đã phê duyệt",
                rejected: "Đã từ chối"
            }
        },
        moderation: {
            title: "Kiểm duyệt nội dung",
            subtitle: "Xem xét và quản lý nội dung giáo dục",
            searchPlaceholder: "Tìm kiếm nội dung...",
            allStatus: "Tất cả trạng thái",
            status: {
                pending: "Đang chờ",
                reviewing: "Đang xem xét",
                approved: "Đã duyệt",
                rejected: "Đã từ chối",
                flagged: "Đã đánh dấu"
            },
            pending: "Chờ xem xét",
            reviewing: "Đang xem xét",
            flagged: "Nội dung bị đánh dấu",
            approvedToday: "Đã duyệt hôm nay",
            submittedAt: "Đã nộp lúc"
        },
        priority: {
            title: "Độ ưu tiên",
            all: "Tất cả mức độ ưu tiên",
            high: "Cao",
            medium: "Trung bình",
            low: "Thấp"
        },
        userTypes: {
            teacher: "Giáo viên",
            student: "Học sinh"
        },
        allUserTypes: "Tất cả loại người dùng",
        userType: "Loại người dùng",
        documentType: "Loại tài liệu",
        documentTypes: {
            all: "Tất cả loại tài liệu",
            learning_material: "Tài liệu học tập",
            reference_material: "Tài liệu tham khảo",
            research_paper: "Bài nghiên cứu",
            study_guide: "Hướng dẫn học tập"
        },
        institutionType: "Loại trường",
        major: "Chuyên ngành",
        classYear: "Khóa học",
        uploadedAt: "Tải lên lúc"
    },
    errors: {
        unauthorized: "Không có quyền truy cập",
        notFound: "Không tìm thấy trang",
        serverError: "Lỗi máy chủ",
        networkError: "Lỗi kết nối",
        unknownError: "Lỗi không xác định"
    },
    public: {
        about: "Giới thiệu",
        features: "Tính năng",
        contact: "Liên hệ",
        tagline: "Nền tảng quản lý bản quyền và cấp phép số hàng đầu Việt Nam",
        company: "Công ty",
        team: "Đội ngũ",
        careers: "Tuyển dụng",
        resources: "Tài nguyên",
        blog: "Blog",
        help: "Trợ giúp",
        faq: "FAQ",
        legal: "Pháp lý",
        privacyPolicy: "Chính sách bảo mật",
        termsOfService: "Điều khoản dịch vụ",
        cookiePolicy: "Chính sách cookie",
        connect: "Kết nối",
        allRightsReserved: "Tất cả các quyền được bảo lưu"
    }
};
